export enum ZmyleLinks {
  ZMYLE_PAGE = 'https://zmyle.de',
  LEGAL_INFO = 'https://legal.zmyle.de/sonstiges/imprint',
  PRIVACY_POLICY = 'https://legal.zmyle.de/privacy-policy/datenschutzerklaerung',
  OUTLETS = '/akzeptanzstellen-unsere-geschaefte',
  STORES = '/stores/',
  BACKOFFICE_LOGIN = '/backoffice/login',
  ICON_SQUARE = 'https://zmyle.libpx.com/eu-west-1/static/zmyle-icon-sq.png',
}

export enum Paths {
  GIFTCARD_SECRET_PAGE = '/g/[giftcardId]',
  GIFTCARD_MESSAGE_PAGE = '/g/[giftcardId]/message',
  GIFTCARD_REDEEM_PAGE = '/g/[giftcardId]/redeem',
  GIFTCARD_OFFER_REDEEM = '/g/[giftcardId]/offer-redeem',
  GIFTCARD_TRANSACTIONS = '/g/[giftcardId]/transactions',
  GIFTCARD_DOWNLOAD_PAGE = '/g/[giftcardId]/download',
  GIFTCARD_SEND_PAGE = '/g/[giftcardId]/send',
  GIFTCARD_FETCH_PAGE = '/g/[giftcardId]/fetch',
  GIFTCARD_COLLECT_PAGE = '/g/[giftcardId]/collect',
  GIFTCARD_QR_CODE = '/g/[giftcardId]/qr-code',
  GIFTCARD_TRANSACTIONS_DETAILS = '/g/[giftcardId]/transactions/[transactionId]',
  CARD_INFO = '/g/cardinfo',

  GIFTCARDS_DEPOT_PAGE = '/g/[giftcardId]/depot_card',
  GIFTCARDS_DEPOT_TRANSACTIONS_PAGE = '/g/[giftcardId]/depot_card/transactions',

  CHECKOUT = '/checkout',
  CHECKOUT_CONTEXT = '/checkout/[contextId]',

  CHECKOUT_DIGITAL = '/digital',
  CHECKOUT_DIGITAL_AMOUNT = '/digital/amount',
  CHECKOUT_DIGITAL_MESSAGE = '/digital/message',
  CHECKOUT_DIGITAL_USER_INFO = '/digital/userInfo',
  CHECKOUT_DIGITAL_PAYMENT = '/digital/payment',
  CHECKOUT_DIGITAL_PROCESSING = '/digital/processing',

  CHECKOUT_PDF = '/pdf',
  CHECKOUT_PDF_GIFTCARDS = '/pdf/giftcards',
  CHECKOUT_PDF_PICTURE = '/pdf/picture',
  CHECKOUT_PDF_USER_INFO = '/pdf/userInfo',
  CHECKOUT_PDF_PAYMENT = '/pdf/payment',
  CHECKOUT_PDF_PROCESSING = '/pdf/processing',

  CHECKOUT_PRINT = '/print',
  CHECKOUT_PRINT_GIFTCARDS = '/print/giftcards',
  CHECKOUT_PRINT_PICTURE = '/print/picture',
  CHECKOUT_PRINT_USER_INFO = '/print/userInfo',
  CHECKOUT_PRINT_PAYMENT = '/print/payment',
  CHECKOUT_PRINT_PROCESSING = '/print/processing',

  KIOSK = '/kiosk',
  KIOSK_PROCESSING = '/kiosk/processing',
  KIOSK_RECEIPT = '/kiosk/receipt',
  KIOSK_EMAIL = '/kiosk/email',
  KIOSK_SUCCESS = '/kiosk/success',
  KIOSK_CLOSE = '/kiosk/close',
}

export enum Endpoints {
  NETWORKS = '/networks',
  WHOAMI = '/accounts/whoami',

  ERROR_PAGE_CONTENT = 'content/error',
  APP_LAYOUT_CONTENT = 'content/layout',

  ERRORS_WHITELIST = 'downloads/whitelists/errors',
  RATE_LIMIT_ME = 'rateLimit/me',

  MARKETPLACE = '/marketplaces/[marketplaceId]',

  GIFTCARD_INFO = '/giftcards/[giftcardId]/info',
  GIFTCARD_DETAILS = '/giftcards/[giftcardId]',
  SEND_GIFTCARD_SECRET_LINK = '/giftcards/[giftcardId]/sendSecretLink',
  REDEEM_GIFTCARD = '/giftcards/[giftcardId]/redeem',
  ACTIVATE_GIFTCARD = '/giftcards/[giftcardId]/activate',
  ACTIVATE_SPONSORED_GIFTCARD = '/giftcards/[giftcardId]/activateSponsored',
  GIFTCARD_STORES = '/giftcards/[giftcardId]/stores',
  SEND_EMAIL_TO_RECEIVER = '/giftcards/[giftcardId]/sendEmailToReceiver',
  GIFTCARD_PDF = '/giftcards/[giftcardId]/pdf',
  GIFTCARD_TRANSACTIONS = '/giftcards/[giftcardId]/transactions',
  GIFTCARD_TRANSACTIONS_DETAILS = '/giftcards/[giftcardId]/transactions/[transactionId]',
  GIFTCARD_VALIDATE_REDEEM_PAGE_PIN = '/giftcards/[giftcardId]/validateRedeemPagePin',
  GIFTCARD_DEPRECIATION_SCHEDULES = '/giftcards/[giftcardId]/depreciationSchedules',

  GIFTCARD_DEPOT = '/giftcardDepots/[giftcardDepotId]',
  GIFTCARD_DEPOT_GIFTCARD_TRANSACTIONS = '/giftcardDepots/[giftcardDepotId]/giftcardTransactions',

  RESERVE_GIFTCARD_CAMPAIGN_FUNDS = '/campaigns/[campaignId]/reserveFunds',
  FIND_ACTIVE_CAMPAIGNS = '/campaigns/findActiveCampaigns',

  RESOLVE_CHECKOUT_CONTEXT = '/contexts/resolve',
  GIFTCARD_ORDERS = '/giftcardOrders',
  KIOSK_GIFTCARD_ORDER = '/giftcardOrders/kiosk',
  GIFTCARD_ORDER = '/giftcardOrders/[giftcardOrderId]',
  GIFTCARD_ORDER_GIFTCARDS = '/giftcardOrders/[giftcardOrderId]/giftcards',
  GIFTCARD_ORDER_UPDATE_BUYER = '/giftcardOrders/[giftcardOrderId]/buyer',
  RESERVE_GIFTCARD_ORDER_CAMPAIGN_FUNDS = '/giftcardOrders/campaign/reserveFunds',
  GIFTCARD_ORDER_RESERVATION_STATUS = '/giftcardOrders/[giftcardOrderId]/campaign/reservationStatus',
  GIFTCARD_ORDER_ZMYLE_PAYMENT = '/giftcardOrders/[giftcardOrderId]/payments/zmyleTest',
  GIFTCARD_ORDER_STRIPE_PAYMENT_INTENT = '/giftcardOrders/[giftcardOrderId]/payments/stripe/createPaymentIntent',
  GIFTCARD_ORDER_CREATE_PAYPAL_PAYMENT = '/giftcardOrders/[giftcardOrderId]/payments/paypal/create',
  GIFTCARD_ORDER_EVALUATE_PAYPAL_PAYMENT = '/giftcardOrders/[giftcardOrderId]/payments/paypal/evaluate',
  GIFTCARD_ORDER_CAPTURE_PAYPAL_PAYMENT = '/giftcardOrders/[giftcardOrderId]/payments/paypal/capture',
  GIFTCARD_ORDER_REISSUE_AUTH_PAYPAL_PAYMENT = '/giftcardOrders/[giftcardOrderId]/payments/paypal/reissueAuth',
  GIFTCARD_ORDER_AUTHORIZE_PAYPAL_PAYMENT = '/giftcardOrders/[giftcardOrderId]/payments/paypal/authorize',
}
